export default function getTotalSvusOnActionLatestProgress(completedActions) {
  return completedActions
    .map((action) => action.v2Dto.progress.slice(-1)[0])
    .reduce(
      (total, step) => total + (step.svusPostPromo || step.svusPrePromo),
      0,
    );
}
